import Layout from "@/layout";

export default {
  path: "/reactive",
  component: Layout,
  redirect: "/reactive/index",
  hidden: true,
  children: [
    {
      path: 'index',
      name: "Reactive",
      component: () => import(/* webpackChunkName: "reactive" */ "@/views/reactive")
    }
  ]
}